/**
 * Await cache-primer prefetches that route rendering or loader-derived head
 * data reads from the QueryClient immediately after the prefetch finishes.
 *
 * TanStack Start loaders are isomorphic. The router's React Query integration
 * owns SSR dehydration and hydration; browser navigations populate the browser
 * QueryClient directly.
 */
export async function prefetchForSsr(promises: Array<Promise<unknown>>): Promise<void> {
  if (typeof window === "undefined") {
    await Promise.all(promises);
    return;
  }
  for (const p of promises) void p.catch(() => {});
}
